export default __webpack_public_path__ + "static/media/Backspace.4cfb6e61.svg";